/* eslint-disable jsx-a11y/no-static-element-interactions */
import { ForwardedRef, forwardRef } from 'react';
import styles from '@features/categories/components/CategoriesFilterRange/CategoriesFilterRange.styles';
import FilterRangeState from '@features/categories/mobx/state/FilterRangeState';
type PropsType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: any;
  children: React.ReactNode;
  value: number[];
  filter: FilterRangeState;
};
const CategoriesFilterRangeTrack = forwardRef(({
  props,
  children,
  value,
  filter
}: PropsType, ref: ForwardedRef<HTMLDivElement>) => <div onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} sx={styles.trackContainer(props.style)}>
      <div ref={ref} sx={styles.track(value, filter.defaultValue)}>
        {children}
      </div>
    </div>);
CategoriesFilterRangeTrack.displayName = 'CategoriesFilterRangeTrack';
export default CategoriesFilterRangeTrack;